@if (removable()) {
<section class="product-card-include">

  <h4 class="product-card-include__title" (click)="goToProduct()" ngbTooltip="{{product()?.name}}">
    {{ product()?.name }}
  </h4>

  <div class="d-flex justify-content-between align-content-center gap-2">

    <!-- Detail -->
    <div class="d-flex gap-2">

      <a (click)="goToProduct()" class="product-card-include__img">
        <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" alt="image" />
      </a>

      <div class="product-card-include__detail">
        <span class="meta">
          {{ product()?.display }}
        </span>
        <h4 class="price">
          {{ product()?.price | currency }}
        </h4>
      </div>

    </div>

    <div class="product-card-include__quantity">
      <!-- Quantity -->
      <div class="d-flex gap-3">

        @if(!isLockedBundle()) {
        <span class="icon" [class.cursor-not-allowed]="(product()?.quantity ?? 0) <= 1" (click)="lessQuantity()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12l14 0" />
          </svg>
        </span>
        }

        <span class="h5-bold">
          {{product()?.quantity}}
        </span>

        @if(!isLockedBundle()) {
        <span class="icon" (click)="addQuantity()" [class.cursor-not-allowed]="(product()?.quantity ?? 0) === (product()?.qtyLimit || 3)">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 5l0 14" />
            <path d="M5 12l14 0" />
          </svg>
        </span>
        }

      </div>

      <!-- Action -->
      @if(!isLockedBundle()) {
      <span class="product-card-include__icon" (click)="remove()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 7l16 0" />
          <path d="M10 11l0 6" />
          <path d="M14 11l0 6" />
          <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
          <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
        </svg>
      </span>
      }
    </div>

  </div>

</section>
} @else {
<div class="product-card-addon">

  <a (click)="goToProduct()" class="product-card-addon__img"
    [class.opacity-50]="(isOOS() || isOOSPerQtty()) && !removable()">
    <img [src]="product()?.img || 'assets/images/product-placeholder.webp'" alt="image" />
  </a>

  <div class="product-card-addon__detail">

    @if ((!isLimitedUser() || isLockedBundle()) && !removable()) {
    <h4 class="price">{{ product()?.price | currency }}</h4>
    }

    <span class="meta mb-1">
      {{ product()?.display }}
    </span>

    <h4 class="title" (click)="goToProduct()" ngbTooltip="{{product()?.name}}"
      [class.opacity-50]="(isOOS() || isOOSPerQtty()) && !removable()">
      {{ product()?.name }}
    </h4>

    <span class="meta">
      {{ product()?.attribute?.name || product()?.package?.name }}
    </span>

  </div>

  @if (isOOSPerQtty()) {
  <app-empty-message [displayIcon]="true" [tinny]="true" class="text-center" [marginTop0]="true"
    [alertMartginBottom0]="false" [message]="oosMessage()"></app-empty-message>
  }

  @if (isOOS()) {
  <div class="product-card-addon__full-widht">
    <app-empty-message [displayIcon]="true" [marginTop0]="true" [tinny]="true" [alertMartginBottom0]="true"
      [width100]="true" class="text-center" [message]="oosMessage()"></app-empty-message>
  </div>
  } @else {
  <div class="product-card-addon__action">
    @if (!isLockedBundle() || product().isPremiumAddon) {
    <div class="action-input">
      <mat-form-field class="field-small" subscriptSizing="dynamic">
        @if( productCardService.isQuantityHighOrPreviouslyHigh() ){
        <input type="text" matInput appOnlyNumber (keyup)="handleKeyUp($event.target)"
          [value]="productCardService.newQuantity()">
        }
        @else{
        <mat-select [value]="product()?.quantity" (selectionChange)="handleChangeQuantitySelect($event.value)">
          @for(item of availableQuantity(); track $index){
          <mat-option [value]="item.id">{{ item.text }}</mat-option>
          }
        </mat-select>
        }
      </mat-form-field>
    </div>
    <div class="action-btn">
      @if (removable()) {
      <button type="button" (click)="remove()" class="btn btn-outline-primary btn-sm px-4 py-2">
        <span class="material-symbols-outlined icon">
          delete
        </span>
        <span class="text">Remove</span>
      </button>
      } @else {
      <button type="button" (click)="add()" class="btn btn-primary btn-sm px-4 py-2" [disabled]="isOOSPerQtty()">
        <span class="material-symbols-outlined icon">
          add
        </span>
        <span class="text">Add</span>
      </button>
      }
    </div>
    } @else {
    <mat-form-field class="d-flex " subscriptSizing="dynamic">
      <input type="text" readonly matInput appOnlyNumber [value]="newQuantity()">
    </mat-form-field>
    }
  </div>
  }

  <!-- Tags Icons -->
  <ul class="product-card__tags">
    @for (tag of product()?.tags || []; track $index) {
    <li>
      @if (tag.icon) {
      <img src="{{tag.icon}}" [alt]="tag.name" [ngbTooltip]="tag.name" />
      } @else {
      <span class="material-symbols-outlined" [ngbTooltip]="tag.name">
        info
      </span>
      }
    </li>
    }
  </ul>

</div>
}
